import { bigIntToLong } from '#common/util';
import { ApplyDataMsg, KeyRangeDataMsg, KeyRangeMsg, MetaStoreRequestMsg, ServiceBaseProto, VersionMsg, } from '#websocket/client/proto';
import { META_STORE_REQUEST_TYPE, META_STORE_RESPONSE_TYPE } from './types';
export class ApplyDataRequest {
    rangeStart;
    rangeLimit;
    data;
    startTime;
    currentTime;
    nodeId;
    epoch;
    connection;
    destination;
    constructor(rangeStart, rangeLimit, data, startTime, currentTime, nodeId, epoch, connection, destination) {
        this.rangeStart = rangeStart;
        this.rangeLimit = rangeLimit;
        this.data = data;
        this.startTime = startTime;
        this.currentTime = currentTime;
        this.nodeId = nodeId;
        this.epoch = epoch;
        this.connection = connection;
        this.destination = destination;
    }
    createMessage(requestId, version) {
        const applyMessage = this.createApplyDataMessage();
        const metaStoreRequest = MetaStoreRequestMsg.create({
            type: MetaStoreRequestMsg.RequestType.APPLY_DATA_REQUEST,
            apply: applyMessage,
        });
        return ServiceBaseProto.RequestMsg.create({
            id: bigIntToLong(requestId),
            versionMajor: version.major,
            versionMinor: version.minor,
            versionBuild: version.build,
            [META_STORE_REQUEST_TYPE]: metaStoreRequest,
        });
    }
    createTimeVersionMessage(version) {
        return VersionMsg.create({
            nodeId: version.nodeId,
            value: bigIntToLong(version.value),
        });
    }
    createApplyDataMessage() {
        const range = KeyRangeMsg.create({
            start: this.rangeStart,
            limit: this.rangeLimit,
        });
        const sendData = this.data.map((kv) => {
            return new ServiceBaseProto.KeyValueMsg({ key: kv.key, value: kv.value });
        });
        const dataMessage = KeyRangeDataMsg.create({
            range: range,
            data: sendData,
        });
        const applyMessage = ApplyDataMsg.create({
            data: dataMessage,
            startTime: this.createTimeVersionMessage(this.startTime),
            currentTime: this.createTimeVersionMessage(this.currentTime),
            nodeId: this.nodeId,
            epoch: bigIntToLong(this.epoch),
            connection: bigIntToLong(this.connection),
        });
        return applyMessage;
    }
    createResponse(responseMessage) {
        return new ApplyDataResponse(responseMessage);
    }
    getDestination() {
        return this.destination;
    }
}
export class ApplyDataResponse {
    result;
    constructor(response) {
        const responseMsgObject = ServiceBaseProto.ResponseMsg.toObject(response);
        this.result = responseMsgObject[META_STORE_RESPONSE_TYPE].apply;
    }
}
